/**
 * The id of the enclosing FormField's label (unique, from useId), for a
 * control that shows its value as text — a picker button — to name itself
 * "label + value" through aria-labelledby. Undefined outside a FormField.
 */

import { createContext, useContext } from 'react';

export const FormFieldLabelContext = createContext<string | undefined>(undefined);

export const useFormFieldLabelId = () => useContext(FormFieldLabelContext);
